import {connect} from 'react-redux';

import PlansScreen from '../components/PlansScreen';

const mapStateToProps = state => {
  return {
    total: state.plans.get('total'),
    isLoading: state.plans.get('isLoading')
  }
}

const PlansScreenContainer = connect(
  mapStateToProps
)(PlansScreen);

export default PlansScreenContainer;
